module.exports = __webpack_public_path__ + "static/img/iconAvatar-1.0d6b0e61.png";